export default __webpack_public_path__ + "static/media/(Fast) SAE.d5bdf852.svg";